// ─────────────────────────────────────────────────────────────
// AUTH TOKEN UTILITIES
// ─────────────────────────────────────────────────────────────
// S4 (Session 21): Normal sessions now use httpOnly cookies.
// JavaScript no longer reads or writes the session token.
//
// getToken() returns ONLY the impersonation token from sessionStorage.
// Normal session requests send no Authorization header — the browser
// automatically includes the httpOnly 'st_token' cookie instead.
//
// Impersonation tabs set their token via setImpersonationToken() and
// it is sent as a Bearer header (cookies are not tab-scoped).
// ─────────────────────────────────────────────────────────────

const IMP_TOKEN_KEY = '__active_impersonate_token';

export const getToken = () => {
  // Only return impersonation token — normal session uses httpOnly cookie
  return window.sessionStorage.getItem(IMP_TOKEN_KEY) || null;
};

export const clearAuth = () => {
  const impToken = window.sessionStorage.getItem(IMP_TOKEN_KEY);
  if (impToken) {
    window.sessionStorage.removeItem(IMP_TOKEN_KEY);
    window.sessionStorage.removeItem('__active_impersonate_user');
  } else {
    // Normal session: cookie is cleared server-side on /logout/
    // Only clean up non-sensitive localStorage items
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('selected_club_id');
    window.localStorage.removeItem('isDemo');
  }
};

// setToken is kept for backward compatibility but is now a no-op.
// Normal sessions use httpOnly cookies set by the server on /login/.
export const setToken = (_token) => { /* no-op — cookie set by server */ };

export const setImpersonationToken = (token) => {
  if (token === null) {
    window.sessionStorage.removeItem(IMP_TOKEN_KEY);
    window.sessionStorage.removeItem('__active_impersonate_user');
    return;
  }
  window.sessionStorage.setItem(IMP_TOKEN_KEY, token);
};

export const clearImpersonationToken = () => {
  window.sessionStorage.removeItem(IMP_TOKEN_KEY);
  window.sessionStorage.removeItem('__active_impersonate_user');
};

export const clearLocalAuth = () => {
  window.localStorage.removeItem('user');
  window.localStorage.removeItem('selected_club_id');
  window.localStorage.removeItem('isDemo');
};
